var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoginIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 84,
    viewBox: "0 0 84 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_131_2493)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 1,
    width: 80,
    height: 80,
    rx: 16,
    fill: "#5F38FA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 1,
    width: 80,
    height: 80,
    rx: 16,
    fill: "url(#paint0_linear_131_2493)",
    fillOpacity: 0.16
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.5,
    y: 1.5,
    width: 79,
    height: 79,
    rx: 15.5,
    stroke: "url(#paint1_linear_131_2493)",
    strokeOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.8312 23.0831C33.9113 23.0831 33.9925 23.0831 34.075 23.0831H49.925C50.0074 23.0831 50.0887 23.0831 50.1688 23.0831C51.8634 23.0823 53.0296 23.0818 54.0118 23.4236C55.8667 24.069 57.3069 25.5618 57.9244 27.4423L56.7367 27.8322L57.9244 27.4423C58.2511 28.4375 58.2507 29.6206 58.25 31.3773C58.25 31.4559 58.25 31.5356 58.25 31.6166V54.9568C58.25 57.3989 55.3717 58.8527 53.476 57.118C53.3435 56.9968 53.1565 56.9968 53.024 57.118L52.2188 57.8548C50.6719 59.2704 48.3281 59.2704 46.7811 57.8548C46.1895 57.3134 45.3105 57.3134 44.7188 57.8548C43.1719 59.2704 40.8281 59.2704 39.2811 57.8548C38.6895 57.3134 37.8105 57.3134 37.2188 57.8548C35.6719 59.2704 33.3281 59.2704 31.7811 57.8548L30.976 57.118C30.8435 56.9968 30.6565 56.9968 30.524 57.118C28.6283 58.8527 25.75 57.3989 25.75 54.9568V31.6166C25.75 31.5356 25.75 31.4559 25.7499 31.3773C25.7493 29.6206 25.7489 28.4375 26.0756 27.4423C26.6931 25.5618 28.1332 24.069 29.9882 23.4236C30.9704 23.0818 32.1366 23.0823 33.8312 23.0831ZM34.075 25.5831C32.0399 25.5831 31.3389 25.6006 30.8098 25.7847C29.7108 26.1671 28.8319 27.0618 28.4509 28.2222C28.2657 28.7861 28.25 29.5296 28.25 31.6166V54.9568C28.25 55.1553 28.3499 55.2765 28.4752 55.3344C28.5404 55.3646 28.6043 55.3724 28.6575 55.3653C28.7044 55.3591 28.7651 55.3388 28.8363 55.2737C29.9241 54.2782 31.5759 54.2782 32.6637 55.2737L33.4688 56.0104C34.0605 56.5518 34.9395 56.5518 35.5311 56.0104C37.0781 54.5948 39.4219 54.5948 40.9688 56.0104C41.5605 56.5518 42.4395 56.5518 43.0311 56.0104C44.5781 54.5948 46.9219 54.5948 48.4688 56.0104C49.0605 56.5518 49.9395 56.5518 50.5311 56.0104L51.3363 55.2737C52.4241 54.2782 54.0759 54.2782 55.1637 55.2737C55.2349 55.3388 55.2956 55.3591 55.3425 55.3653C55.3957 55.3724 55.4595 55.3646 55.5248 55.3345C55.6501 55.2765 55.75 55.1553 55.75 54.9568V31.6166C55.75 29.5296 55.7342 28.7861 55.5491 28.2222C55.1681 27.0618 54.2892 26.1671 53.1902 25.7847C52.6611 25.6006 51.9601 25.5831 49.925 25.5831H34.075ZM46.9992 33.4007C47.5141 33.8605 47.5589 34.6507 47.0991 35.1657L41.1467 41.8323C40.9095 42.0979 40.5704 42.2498 40.2143 42.2498C39.8582 42.2498 39.519 42.0979 39.2819 41.8323L36.9009 39.1657C36.4411 38.6507 36.4858 37.8605 37.0008 37.4007C37.5158 36.9409 38.306 36.9857 38.7657 37.5006L40.2143 39.123L45.2342 33.5006C45.694 32.9857 46.4842 32.9409 46.9992 33.4007ZM33.25 46.8331C33.25 46.1428 33.8096 45.5831 34.5 45.5831H49.5C50.1903 45.5831 50.75 46.1428 50.75 46.8331C50.75 47.5235 50.1903 48.0831 49.5 48.0831H34.5C33.8096 48.0831 33.25 47.5235 33.25 46.8331Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_131_2493",
    x: 0,
    y: 0,
    width: 84,
    height: 84,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_131_2493"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.24947 0 0 0 0 0.0737931 0 0 0 0 0.957056 0 0 0 0.76 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_131_2493"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.148846 0 0 0 0 0.0746738 0 0 0 0 0.447596 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_131_2493",
    result: "effect2_dropShadow_131_2493"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_131_2493",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_131_2493",
    x1: 42,
    y1: 1,
    x2: 42,
    y2: 81,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_131_2493",
    x1: 42,
    y1: 1,
    x2: 42,
    y2: 81,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginIcon);
export default __webpack_public_path__ + "static/media/Login-Icon.0959f9ce57f1591c1e30e4fad5010408.svg";
export { ForwardRef as ReactComponent };